import { state } from "./state";
import openModal from "./openModal";
import closeModal from "./closeModal";
import { ModalOptions } from "../types";

export const openModalTracked = (
  elName: string,
  options: ModalOptions,
): void => {
  state.lastModalArgs = { elName, options };
  state.isModalOpen = true;
  const arrowBtn = document.querySelector(".arrow__btn");
  if (arrowBtn) arrowBtn.classList.add("is-open");

  openModal(elName, options);
};

export const closeModalTracked = (): void => {
  state.isModalOpen = false;
  const arrowBtn = document.querySelector(".arrow__btn");
  if (arrowBtn) arrowBtn.classList.remove("is-open");
  if (state.swiperInstance) {
    state.swiperInstance.destroy(true, true);
    state.swiperInstance = null;
  }
  closeModal();
};
